export const ROUTE_ENUMS = {
	ROOT: 'root',
	BILLING: 'billing',
	CONTACTS: 'contacts',
	CONTACTS_CREATE: 'contacts-create',
	CONTACTS_EDIT: 'contacts-edit',
	CONTACTS_LIST: 'contacts-list',
	DASHBOARD: 'dashboard',
	FORGOT_PASSWORD: 'forgot-password',
	FREEBIES_EASY_TRANSCRIBE: 'easy-transcribe',
	FREEBIES_EASY_CONVERT: 'easy-convert',
	FREEBIES_EASY_CROP: 'easy-crop',
	FREEBIES_EASY_CUT: 'easy-cut',
	FREEBIES_EXPOSE: 'expose',
	FREEBIES_QUICKVOICE: 'quickvoice',
	FREEBIES_SIMPLE_HOST: 'simple-host',
	FREEBIES_TRACK_SPLITTER: 'track-splitter',
	LICENSE_AGREEMENT: 'license',
	LINKS: 'links',
	LINKS_CREATE: 'links-create',
	LINKS_LIST: 'links-list',
	LOGIN: 'login',
	MEDIA: 'media',
	MEDIA_DETAIL: 'media-detail',
	MEDIA_LIST: 'media-list',
	MEDIA_PROCESSING: 'media-processing',
	MEDIA_STAGED: 'media-staged',
	MEDIA_UPLOAD: 'media-upload',
	MFA: 'mfa',
	NEW_PASSWORD_REQUIRED: 'new-password-required',
	PERMISSIONS: 'permissions',
	PRICING: 'pricing',
	PRIVACY_POLICY: 'privacy',
	PRODUCTS: 'products',
	PROFILE: 'profile',
	PROFILE_GENERAL: 'profile-general',
	PROFILE_MFA: 'profile-mfa',
	PROJECTS: 'projects',
	PROJECT_CREATE: 'projects-create',
	PROJECT_LIST: 'projects-list',
	REGISTRATION: 'registration',
	SETTINGS: 'settings',
	SIGN_UP: 'sign-up',
	TAGS: 'tags',
	TAGS_CREATE: 'tags-create',
	TAGS_LIST: 'tags-list',
	TERMS_AND_CONDITIONS: 'terms',
	USERS: 'users'
};

const routes = {
	[ROUTE_ENUMS.ROOT]: {
		path: '/',
		protected: false
	},
	[ROUTE_ENUMS.BILLING]: {
		path: '/billing',
		protected: true
	},
	[ROUTE_ENUMS.CONTACTS]: {
		path: '/contacts',
		protected: true
	},
	[ROUTE_ENUMS.CONTACTS_CREATE]: {
		path: '/contacts/create',
		protected: true
	},
	[ROUTE_ENUMS.CONTACTS_EDIT]: {
		path: '/contacts/edit/:id',
		protected: true
	},
	[ROUTE_ENUMS.CONTACTS_LIST]: {
		path: '/contacts/list',
		protected: true
	},
	[ROUTE_ENUMS.DASHBOARD]: {
		path: '/dashboard',
		protected: true
	},
	[ROUTE_ENUMS.FORGOT_PASSWORD]: {
		path: '/forgot-password',
		protected: false
	},
	// ============== FREEBIES ==============
	[ROUTE_ENUMS.FREEBIES_EASY_TRANSCRIBE]: {
		path: '/freebies/easy-transcribe',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_EASY_CONVERT]: {
		path: '/freebies/easy-convert',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_EASY_CROP]: {
		path: '/freebies/easy-crop',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_EASY_CUT]: {
		path: '/freebies/easy-cut',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_EXPOSE]: {
		path: '/freebies/expose',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_QUICKVOICE]: {
		path: '/freebies/quickvoice',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_SIMPLE_HOST]: {
		path: '/freebies/simple-host',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_TRACK_SPLITTER]: {
		path: '/freebies/track-splitter',
		protected: false
	},
	[ROUTE_ENUMS.FREEBIES_RESULTS]: {
		path: '/freebies/results',
		protected: false
	},
	// =====================================
	[ROUTE_ENUMS.LICENSE_AGREEMENT]: {
		path: '/license',
		protected: false
	},
	[ROUTE_ENUMS.LINKS]: {
		path: '/links',
		protected: true
	},
	[ROUTE_ENUMS.LINKS_CREATE]: {
		path: '/links/create',
		protected: true
	},
	[ROUTE_ENUMS.LINKS_LIST]: {
		path: '/links/list',
		protected: true
	},
	[ROUTE_ENUMS.LOGIN]: {
		path: '/login',
		protected: false
	},
	[ROUTE_ENUMS.MEDIA]: {
		path: '/media',
		protected: true
	},
	[ROUTE_ENUMS.MEDIA_DETAIL]: {
		path: '/media/:id',
		protected: true
	},
	[ROUTE_ENUMS.MEDIA_LIST]: {
		path: '/media/list',
		protected: true
	},
	[ROUTE_ENUMS.MEDIA_PROCESSING]: {
		path: '/media/processing',
		protected: true
	},
	[ROUTE_ENUMS.MEDIA_STAGED]: {
		path: '/media/staged',
		protected: true
	},
	[ROUTE_ENUMS.MEDIA_UPLOAD]: {
		path: '/media/upload',
		protected: true
	},
	[ROUTE_ENUMS.MFA]: {
		path: '/mfa',
		protected: false
	},
	[ROUTE_ENUMS.NEW_PASSWORD_REQUIRED]: {
		path: '/new-password-required',
		protected: false
	},
	[ROUTE_ENUMS.PERMISSIONS]: {
		path: '/permissions',
		protected: true
	},
	[ROUTE_ENUMS.PRICING]: {
		path: '/pricing',
		protected: false
	},
	[ROUTE_ENUMS.PRODUCTS]: {
		path: '/products',
		protected: false
	},
	[ROUTE_ENUMS.PRIVACY_POLICY]: {
		path: '/privacy',
		protected: false
	},
	[ROUTE_ENUMS.PROFILE]: {
		path: '/profile',
		protected: true
	},
	[ROUTE_ENUMS.PROFILE_GENERAL]: {
		path: '/profile/general',
		protected: true
	},
	[ROUTE_ENUMS.PROFILE_MFA]: {
		path: '/profile/mfa',
		protected: true
	},
	[ROUTE_ENUMS.PROJECTS]: {
		path: '/projects',
		protected: true
	},
	[ROUTE_ENUMS.PROJECT_CREATE]: {
		path: '/projects/create',
		protected: true
	},
	[ROUTE_ENUMS.PROJECT_LIST]: {
		path: '/projects/list',
		protected: true
	},
	[ROUTE_ENUMS.REGISTRATION]: {
		path: '/registration',
		protected: false
	},
	[ROUTE_ENUMS.SETTINGS]: {
		path: '/settings',
		protected: true
	},
	[ROUTE_ENUMS.SIGN_UP]: {
		path: '/sign-up',
		protected: false
	},
	[ROUTE_ENUMS.SIGN_UP_SUCCESS]: {
		path: '/sign-up/:id',
		protected: false
	},
	[ROUTE_ENUMS.TAGS]: {
		path: '/tags',
		protected: true
	},
	[ROUTE_ENUMS.TAGS_CREATE]: {
		path: '/tags/create',
		protected: true
	},
	[ROUTE_ENUMS.TAGS_LIST]: {
		path: '/tags/list',
		protected: true
	},
	[ROUTE_ENUMS.TERMS_AND_CONDITIONS]: {
		path: '/terms',
		protected: false
	},
	[ROUTE_ENUMS.USERS]: {
		path: '/users',
		protected: true
	}
};

export const getUnprotectedRoutes = () => {
	return Object.values(routes)
		.filter((route) => !route.protected)
		.map((route) => route.path);
};

export const getRoute = (route) => {
	if (routes[route]) {
		return routes[route].path;
	} else {
		throw `Route does not exist: ${route}`;
	}
};

export default routes;
